module.exports = __webpack_public_path__ + "img/icon01.61e23b72.png";